import React from 'react';
import { NavLink } from 'react-router-dom';
import { urlCanParse } from 'helpers/urlCanParse';
import PropTypes from 'prop-types';

import { Label } from '@atlas/ui';

const FooterMenuListItem = ({ location, name, onClick }) => {
  return (
    <li
      className="footer__menu__item"
      key={name}
      onClick={onClick}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick(e);
        }
      }}
    >
      {urlCanParse(location) ? (
        <a className="footer__menu__link" href={location}>
          <Label message={name} />
        </a>
      ) : (
        <NavLink className="footer__menu__link" to={location}>
          <Label message={name} />
        </NavLink>
      )}
    </li>
  );
};

FooterMenuListItem.propTypes = {
  location: PropTypes.string,
  name: PropTypes.string,
  onClick: PropTypes.func,
};

export default FooterMenuListItem;
